import { Modal } from "@powerledger/ui-component-lib";

import { OrderLifeCycle } from "../common";
import { BuyForm } from "./buy-form";
import { BuyOrderModalProps } from "./buy-order-modal.types";
import { useBuyOrderModal } from "./use-buy-order-modal";

export const BuyOrderModal: React.FC<BuyOrderModalProps> = ({ defaultAsset, visible, closeModal }) => {
  const logic = useBuyOrderModal({ defaultAsset, closeModal });
  return (
    <Modal
      visible={visible}
      onCancel={closeModal}
      modalMaxWidth="1000px"
      sx={{
        ...(logic.currentStep === OrderLifeCycle.Form
          ? {
              height: window.innerHeight < 800 ? `${window.innerHeight - 100}px !important` : "auto",
              overflow: "auto",
              maxHeight: "inherit",
            }
          : {}),
        color: logic.currentStep === OrderLifeCycle.Success ? "background" : "text",
      }}
    >
      <BuyForm {...logic} />
    </Modal>
  );
};
